import { hexEncoding } from "./encoding";

export function randomHexString(random: Random, length: number) {
  const bytes = random.bytes(Math.ceil(length / 2));
  return hexEncoding.write(bytes).slice(0, length);
}

export interface Random {
  bytes(length: number): ArrayBuffer;
  integer(max: number): number;
}

abstract class RandomBase implements Random {
  bytes(length: number): ArrayBuffer {
    const base = Math.pow(2, 32);
    const buffer = new Uint32Array(
      Math.ceil(length / Uint32Array.BYTES_PER_ELEMENT),
    );
    for (let i = 0; i < buffer.length; i++) {
      buffer[i] = this.integer(base);
    }
    return buffer.buffer.slice(0, length);
  }

  abstract integer(max: number): number;
}

export const cryptoRandom: Random = {
  bytes(length: number): ArrayBuffer {
    return crypto.getRandomValues(new Uint8Array(length));
  },
  integer(max: number): number {
    const values = new Uint32Array(2);
    crypto.getRandomValues(values);
    return Math.floor((values[0] << (32 + values[1])) / max);
  },
};

export const nativeRandom: Random = new (class extends RandomBase {
  integer(max: number): number {
    return Math.floor(Math.random() * max);
  }
})();

export class SeededRandom extends RandomBase {
  private seed: number;
  constructor(seed: number) {
    super();
    this.seed = seed;
  }
  integer(max: number): number {
    const x = Math.sin(this.seed++) * 10_000;
    return Math.floor((x - Math.floor(x)) * (max + 1));
  }
}
